import * as angular from 'angular'

import { reactCustomerModal } from './business-components/CustomerModal/CustomerModalWrapper'
import { CustomerModalController } from './business-components/CustomerModal/customer-modal.controller'

import { reactEditCustomerModal } from './business-components/EditCustomerModal/EditCustomerModalWrapper'
import { EditCustomerModalController } from './business-components/EditCustomerModal/edit-customer-modal.controller'

import { reactProductModal } from './business-components/ProductModal/ProductModalWrapper'
import { ProductModalController } from './business-components/ProductModal/product-modal.controller'

angular
  .module('webregister.components')

  .component('reactCustomerModal', reactCustomerModal)
  .controller('customerModalController', CustomerModalController)

  .component('reactEditCustomerModal', reactEditCustomerModal)
  .controller('editCustomerModalController', EditCustomerModalController)

  .component('reactProductModal', reactProductModal)
  .controller('productModalController', ProductModalController)
